import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import recapAttendance from "../../../containers/modules/hr/recap-attendance";

export default function RecapAttendanceRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="recap-attendance"
      index
      element={
        <AccessControl
          name={"Recap Daily Attendance List"}
          auth={authUser}
          component={recapAttendance}
        />
      }
    ></Route>
  );
}
